export function sendEvent(el: Element, eventName: string) {
  let event;
  if (typeof Event === "function") {
    event = new Event(eventName); //, {"bubbles":true}
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
  }
  el.dispatchEvent(event);
}

export function sendCustomEvent(el: Element, name: string, parameters: object) {
  let event;
  if (typeof CustomEvent === "function") {
    event = new CustomEvent(name, { detail: parameters });
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(name, true, false, { detail: parameters });
  }
  el.dispatchEvent(event);
}
